// This is for mobile device default printer selections for printing labels & reports
import React, { useContext, useEffect, useState } from 'react';
import { Col, Row } from 'reactstrap';
import { toast } from "react-toastify";
import _ from 'lodash';
import { FilterSelect, ServiceThreadSpinner } from '.';
import { DesktopContainer } from '../layouts';
import { api, filterHelpers, UserContext } from '../utils';

export default function PrinterSettings() {
   const NO_SELECTION = { value: 0, label: "NONE" };
   const { currentUser } = useContext(UserContext);
   const [data, setData] = useState(null);
   const [filters, setFilters] = useState([
      { filterName: "label", value: NO_SELECTION },
      { filterName: "laser", value: NO_SELECTION },
      { filterName: "part", value: NO_SELECTION },
   ]);
   const [labelOptions, setLabels] = useState([]); // zebra label printer selections
   const [laserOptions, setLasers] = useState([]); // laser printer selections
   const [loaded, setLoaded] = useState(false);
   const [partOptions, setParts] = useState([]);   // parts label printer selections

   useEffect(() => {
      // Get possible drop-down options
      if (!currentUser) return;
      api
         .fetch(`Printer/LoadPrinterDropdowns`)
         .then(response => {
            if (response.data.success) {
               const labelPrinters = _.concat(_.map(response.data.labels, p => ({ value: p.id, label: p.name })));
               const laserPrinters = _.concat(_.map(response.data.lasers, p => ({ value: p.id, label: p.name })));
               const partPrinters = _.concat(_.map(response.data.parts, p => ({ value: p.id, label: p.name })));
               return {
                  labelPrinters: labelPrinters,
                  laserPrinters: laserPrinters,
                  partPrinters: partPrinters
               };
            } else {
               throw new Error(response);
            }
         }).then(({ labelPrinters, laserPrinters, partPrinters }) => {
            setLabels(labelPrinters);
            setLasers(laserPrinters);
            setParts(partPrinters);
            runQuery();
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
         })
   }, [currentUser])

   useEffect(() => {
      async function setDropdowns() {
         if (!loaded && data) {
            // Set ddl selected values based on the user's selected printers
            const labelFilter = (data.labelPrinter) ? _.find(labelOptions, m => m.value === data.labelPrinter) : NO_SELECTION;
            let newFilters = filterHelpers.getFilters(filters, { filterName: "label", value: labelFilter });

            const laserFilter = (data.laserPrinter) ? _.find(laserOptions, m => m.value === data.laserPrinter) : NO_SELECTION;
            newFilters = filterHelpers.getFilters(newFilters, { filterName: "laser", value: laserFilter });

            const partFilter = (data.partsPrinter) ? _.find(partOptions, s => s.value === data.partsPrinter) : NO_SELECTION;
            newFilters = filterHelpers.getFilters(newFilters, { filterName: "part", value: partFilter });

            setFilters(newFilters);
            setLoaded(true);
         }
      }
      setDropdowns();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [data])

   function onLabelChange(newFilterValue) {
      let newFilters = filterHelpers.getFilters(filters, newFilterValue);
      setFilters(newFilters);

      let changes = Object.assign({}, data);
      changes.labelPrinter = newFilterValue.value;
      setData(changes);
      saveSelection(changes);
   }

   function onLaserChange(newFilterValue) {
      let newFilters = filterHelpers.getFilters(filters, newFilterValue);
      setFilters(newFilters);

      let changes = Object.assign({}, data);
      changes.laserPrinter = newFilterValue.value;
      setData(changes);
      saveSelection(changes);
   }

   function onPartChange(newFilterValue) {
      let newFilters = filterHelpers.getFilters(filters, newFilterValue);
      setFilters(newFilters);

      let changes = Object.assign({}, data);
      changes.partsPrinter = newFilterValue.value;
      setData(changes);
      saveSelection(changes);
   }

   function runQuery() {
      api
         .fetch(`Printer/GetDefaultPrinters`)
         .then(response => {
            if (response.data.success) {
               setData(response.data.printers);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
         });
   }

   function saveSelection(changes) {
      api
         .post(`Printer/SaveDefaultPrinters`, changes)
         .then(response => {
            if (response.data.success) {
               toast.success('Printer change succesful!');
            }
            else {
               toast.error(response.data.message);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
         });
   }

   return (
      <DesktopContainer screenName="Default Printer Selections">
         <ServiceThreadSpinner on={!loaded}>
            <div className="filter-header">
               <Row className="justify-content-center">
                  <Col xs={10}>
                     <Row>
                        <Col className="text-white h6 fw-bold my-0">
                           Label:
                        </Col>
                     </Row>
                     <Row>
                        <Col>
                           <FilterSelect
                              filterName="label"
                              options={labelOptions}
                              value={filterHelpers.getValue(filters, "label")}
                              onChangeCallback={e => onLabelChange(e)}
                           />
                        </Col>
                     </Row>
                     <Row className="lineheight15">&nbsp;</Row>
                     <Row>
                        <Col className="text-white h6 fw-bold my-0">
                           Laser:
                        </Col>
                     </Row>
                     <Row>
                        <Col>
                           <FilterSelect
                              filterName="laser"
                              options={laserOptions}
                              value={filterHelpers.getValue(filters, "laser")}
                              onChangeCallback={e => onLaserChange(e)}
                           />
                        </Col>
                     </Row>
                     <Row className="lineheight15">&nbsp;</Row>
                     <Row>
                        <Col className="text-white h6 fw-bold my-0">
                           Parts:
                        </Col>
                     </Row>
                     <Row>
                        <Col>
                           <FilterSelect
                              filterName="part"
                              options={partOptions}
                              value={filterHelpers.getValue(filters, "part")}
                              onChangeCallback={e => onPartChange(e)}
                           />
                        </Col>
                     </Row>
                     <br />
                  </Col>
               </Row>
            </div>
         </ServiceThreadSpinner>
      </DesktopContainer >
   );
}
